/**
 * @file 工具库
 */
import {getPlatInfo} from '@baidu/map-fe-utils';
import util from './tools';

const src = 'cjh.dacheh5';
const utils = {
    /**
     * bdapi接口
     * @param url
     * @param data
     * @param success
     * @param {boolean} clear 是否一次回调后即清除回调函数 默认true
     * @return {string} 生成的回调函数名 外界调用者可根据回调函数名自行清除回调
     */
    requestBdApi(url, data, success, clear) {
        if (util.objectType(data) === 'Function') {
            success = data;
            clear = success;
            data = {};
        }
        // 回调函数名
        let callbackName;
        url = util.appendParam(url, data);
        if (util.objectType(success) === 'Function') {
            url = util.appendCallback(url, success, clear);
            let result = url.match(/(&|\?)callback=([^&#]*)?(&|#|$)/);
            if (result && result[2]) {
                callbackName = result[2];
            }
        }
        util.makeIframeRequest(url, true);
        return callbackName;
    }
};


let ua = navigator.userAgent;
ua = ua.toLowerCase();
let iosReg = /ip(hone|ad|od)/i;
utils.plat = {
    isAndroid: ua.indexOf('android') > -1,
    isIOS: iosReg.test(ua),
    // 微信
    isWeixinWeb: ua.indexOf('micromessenger') > -1 && ua.indexOf('miniprogram') === -1,
    // 手百
    isBaiduApp: ua.indexOf('baiduboxapp') > -1,
    // 京东系
    isJDApp: ua.indexOf('jdjr-app') > -1 || ua.indexOf('jdapp') > -1,
    // 百度小程序，参见文档：http://agroup.baidu.com/share/md/9f62a03fe9dd406a80fdef702163843a
    isBaiduMiniProgram: ua.indexOf('swan') > -1,
    // 微信小程序
    isWeixinMiniProgram: ua.indexOf('micromessenger') > -1 && ua.indexOf('miniprogram') > -1,
    // 建行
    isCCB: typeof window.CCBBridge !== 'undefined',
    // 地图客户端
    isBaiduMapApp: ua.indexOf('baidumap') > -1,
    // 车来了 App
    isChelaile: ua.indexOf('chelaile') > -1,
    // iOS 主版本号
    iOSVersion: (function () {
        // 代码来自：https://stackoverflow.com/questions/8348139/detect-ios-version-less-than-5-with-javascript
        // 略修改
        if (iosReg.test(ua)) {
            // supports iOS 2.0 and later: <http://bit.ly/TJjs1V>
            let v = (navigator.appVersion).match(/OS (\d+)_(\d+)_?(\d+)?/);
            if (v && v[1]) {
                return parseInt(v[1], 10);
            }
            // 微信的小程序壳出现过一次ua异常，没有版本号字段，导致匹配结果v为null，因此取不到的情况需要处理
            // 默认999表示取不到就认为是最新的，999比现在任何版本号都大
            return 999;
        }
        return 0;
    })(),
    // 百度地图 app
    isNative: ua.indexOf('baidumap') > -1
};
utils.plat.isMiniProgram = utils.plat.isBaiduMiniProgram || utils.plat.isWeixinMiniProgram;
export default utils;
